"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonLink = exports.Button = exports.Tick = exports.Loading = exports.Overlay = exports.Chevron = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theme = require("@gymshark/theme");

var _Chevron = _interopRequireDefault(require("@gymshark/icons/dist/Chevron"));

var _Loading = _interopRequireDefault(require("@gymshark/icons/dist/Loading"));

var _Tick = _interopRequireDefault(require("@gymshark/icons/dist/Tick"));

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Chevron = (0, _styledComponents.default)(_Chevron.default).withConfig({
  displayName: "Styles__Chevron",
  componentId: "sc-1kpnvfh-0"
})(["width:1.2rem;height:1.2rem;margin-left:0.5rem;transform:translateY(0.1rem);"]);
exports.Chevron = Chevron;

var Overlay = _styledComponents.default.span.withConfig({
  displayName: "Styles__Overlay",
  componentId: "sc-1kpnvfh-1"
})(["position:absolute;top:0;left:0;width:100%;height:100%;display:block;border-radius:5rem;pointer-events:none;transition:0.2s opacity;opacity:", ";"], function (_ref) {
  var visible = _ref.visible;
  return visible ? '1' : '0';
});

exports.Overlay = Overlay;
var svgStyle = (0, _styledComponents.css)(["width:2rem;height:2rem;position:absolute;top:50%;left:50%;margin:-1rem 0 0 -1rem;"]);
var Loading = (0, _styledComponents.default)(_Loading.default).withConfig({
  displayName: "Styles__Loading",
  componentId: "sc-1kpnvfh-2"
})(["", " height:3rem;width:3rem;margin:-1.5rem 0 0 -1.5rem;transition:0.2s opacity;opacity:", ";animation:", " 1.5s linear infinite;"], svgStyle, function (_ref2) {
  var loading = _ref2.loading;
  return loading ? '1' : '0';
}, _theme.Animations.RotateZ);
exports.Loading = Loading;
var Tick = (0, _styledComponents.default)(_Tick.default).withConfig({
  displayName: "Styles__Tick",
  componentId: "sc-1kpnvfh-3"
})(["", " transition:0.2s opacity;opacity:", ";"], svgStyle, function (_ref3) {
  var success = _ref3.success;
  return success ? '1' : '0';
});
exports.Tick = Tick;
var buttonStyle = (0, _styledComponents.css)(["position:relative;font-family:", ";text-transform:uppercase;font-size:1.4rem;letter-spacing:0.05rem;border-radius:5rem;cursor:pointer;padding:1.5rem 3rem;font-weight:700;outline:none;border:0;text-align:center;", ";&:focus{outline:auto 0.2rem Highlight;outline:-webkit-focus-ring-color auto 0.5rem;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.montserrat;
}, function (_ref5) {
  var isDisabled = _ref5.isDisabled,
      isLoading = _ref5.isLoading,
      isSuccess = _ref5.isSuccess,
      buttonType = _ref5.buttonType,
      theme = _ref5.theme;
  return (0, _styledComponents.css)(["", " ", "{background-color:", ";svg *{fill:", ";}}", " *{fill:", ";}", ""], (0, _helpers.getButtonStyles)(isDisabled, buttonType, theme.c), Overlay, (0, _helpers.getBackgroundColor)(isDisabled, buttonType, theme.c), (0, _helpers.getFontColor)(isDisabled, buttonType, theme.c), Chevron, (0, _helpers.getFontColor)(isDisabled, buttonType, theme.c), (isLoading || isSuccess || isDisabled) && (0, _styledComponents.css)(["pointer-events:none;"]));
});

var Button = _styledComponents.default.button.withConfig({
  displayName: "Styles__Button",
  componentId: "sc-1kpnvfh-4"
})(["", ";"], buttonStyle);

exports.Button = Button;

var ButtonLink = _styledComponents.default.a.withConfig({
  displayName: "Styles__ButtonLink",
  componentId: "sc-1kpnvfh-5"
})(["display:inline-block;", ";"], buttonStyle);

exports.ButtonLink = ButtonLink;